/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stout_Fluffy_Mole_HugInputs */

const fr_stout_fluffy_mole_hug = /** @type {(inputs: Stout_Fluffy_Mole_HugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout afficher`)
};

/**

* @param {Stout_Fluffy_Mole_HugInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stout_fluffy_mole_hug = /** @type {((inputs?: Stout_Fluffy_Mole_HugInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stout_Fluffy_Mole_HugInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stout_fluffy_mole_hug(inputs)
});